import type { GTMEcommerceItem, GTMItemInput } from '../types/gtmTypes'

export function transformListingToGTMItem(
  input: GTMItemInput,
  index: number,
  itemListId?: string,
  itemListName?: string
): GTMEcommerceItem {
  return {
    item_id: input.item_id,
    item_name: input.item_name,
    price: input.price,
    quantity: 1,
    index,
    currency: input.currency || 'USD',
    item_category: input.item_category,
    item_category2: input.item_category2,
    item_category3: input.item_category3,
    item_brand: input.item_brand,
    item_list_id: itemListId,
    item_list_name: itemListName,
    auctionId: input.auctionId,
    listingId: input.listingId,
  }
}
